<template>
  <div v-if="can('edit-registered-device')">
    <h2>Edit Device</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
            name="device_name"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="device_name">Device Name<Astrik /></label>
              <input
                type="text"
                v-model="form.device_name"
                class="form-control"
                id="device_name"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="device_id"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="device_id">Device ID<Astrik /></label>
              <input
                type="text"
                v-model="form.device_id"
                class="form-control"
                id="device_id"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="os_type"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="os_type">OS<Astrik /></label>
              <input
                type="text"
                v-model="form.os_type"
                class="form-control"
                id="os_type"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="sort">Sort<Astrik /></label>
              <input
                type="text"
                v-model="form.sort"
                class="form-control"
                id="sort"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select v-model="form.status" class="form-select">
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Update</button>
            <button type="submit" class="btn btn-danger pull-right">
              Cancel
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditDevice",
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    // if (this.can("edit-registered-device")) {
    this.getSingleDeviceDetail();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    getSingleDeviceDetail() {
      this.$http
        .get("registered-device/" + this.$route.params.id + "/edit")
        .then((res) => {
          this.form = res.data.data;
        });
    },
    onSubmit() {
      this.$http
        .put("registered-device/" + this.$route.params.id, this.form)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Device",
              type: "success",
              text: res.data.message,
            });
            this.$router.push("/admin/device");
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
  },
};
</script>
